import { EditorType } from '@/types/feedback';

export const DEV_FEEDBACK_ID = 'bb89fc76-3a5c-41e1-b508-f0113f9b40a1';

export const DEV_CLIENT_PATH = `/client/${DEV_FEEDBACK_ID}`;

export const DEV_TARGET_URL = 'https://liorshe.wixsite.com/my-site-140';

export function getDevModelData() {
  return {
    metaSiteId: 'cdb23d49-0a78-4c2b-b4f2-f3ea49bbb214',
    feedbackId: DEV_FEEDBACK_ID,
    ownerName: 'Lior Shefer',
    editorType: EditorType.Studio as EditorType | undefined,
  };
}
